(function () {
    angular
        .module('advancedapp')
        .directive('rebindDirective', rebindDirective);

    rebindDirective.$inject = ['$window', '$timeout'];

    function rebindDirective($window, $timeout) {
       
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                results: '=',
                callBackFunction: '&'
            }
        };
        return directive;

        function link(scope, element, attrs) {

         
            scope.$watch('results', function (newVal, oldVal) {

                if ((newVal != null && newVal != oldVal)) {
                    $timeout(function () { scope.callBackFunction(); })
                }
            });           
        }
    }

})();